import {AxiosRequestConfig} from 'axios'
import RequestBase from '../../../api/RequestBase'

const BASE_URL = '/automation-rules'

function getAutomationRulesMetadata(config?: AxiosRequestConfig) {
  return RequestBase.get(`${BASE_URL}/metadata`, config)
}

function listAutomationRules(params?: {is_active?: 0 | 1}, config?: AxiosRequestConfig) {
  return RequestBase.get(BASE_URL, {params, ...config})
}

function getAutomationRuleDetail(id: number, config?: AxiosRequestConfig) {
  return RequestBase.get(`${BASE_URL}/${id}`, config)
}

function createAutomationRule(payload: any, config?: AxiosRequestConfig) {
  return RequestBase.post(BASE_URL, payload, config)
}

function updateAutomationRule(id: number, payload: any, config?: AxiosRequestConfig) {
  return RequestBase.put(`${BASE_URL}/${id}`, payload, config)
}

function deleteAutomationRule(id: number, config?: AxiosRequestConfig) {
  return RequestBase.remove(`${BASE_URL}/${id}`, config)
}

function updateAutomationRuleStatus(
  id: number,
  payload: {is_active: boolean},
  config?: AxiosRequestConfig
) {
  return RequestBase.patch(`${BASE_URL}/${id}/status`, payload, config)
}

function reorderAutomationRules(payload: {rule_ids: number[]}, config?: AxiosRequestConfig) {
  return RequestBase.put(`${BASE_URL}/reorder`, payload, config)
}

function syncAutomationRules(config?: AxiosRequestConfig) {
  return RequestBase.post(`${BASE_URL}/sync`, {}, config)
}

function getSyncResult(processId: string, config?: AxiosRequestConfig) {
  return RequestBase.get(`${BASE_URL}/sync-result`, {params: {process_id: processId}, ...config})
}

const AutomationRulesService = {
  getAutomationRulesMetadata,
  listAutomationRules,
  getAutomationRuleDetail,
  createAutomationRule,
  updateAutomationRule,
  deleteAutomationRule,
  updateAutomationRuleStatus,
  reorderAutomationRules,
  syncAutomationRules,
  getSyncResult,
}

export default AutomationRulesService
